import { APIMain } from "../apiRequester";
import { ApiConstant } from "../const";
import {
  LoginRequestType,
  ITokenLoginResponseModel,
  ChangePasswordType,
  IUserPermissionResponseApiModel,
} from "../models";

export const postLogin = (body: LoginRequestType) => {
  return APIMain.post<ITokenLoginResponseModel>(
    ApiConstant.AUTH_API.POST_LOGIN,
    body,
    {
      skipAuth: true,
    },
  );
};
export const postChangePassword = (body: ChangePasswordType) => {
  return APIMain.post<boolean>(
    ApiConstant.AUTH_API.POST_CHANGE_PASSWORD,
    body
  );
};

export const postRefreshToken = (refreshToken: string) => {
  return APIMain.post<ITokenLoginResponseModel>(
    ApiConstant.AUTH_API.POST_REFRESH_TOKEN,
    {
      refreshToken,
    },
    {
      skipAuth: true,
    },
  );
};

export const getPermissions = (accessToken?: string) => {
  return APIMain.get<IUserPermissionResponseApiModel>(
    ApiConstant.AUTH_API.GET_PERMISSIONS,
    undefined,
    {
      accessToken,
    }
  );
};

export const postLogoutFromNextServerToServer = (refreshToken: string) => {
  return APIMain.post<boolean>(
    ApiConstant.AUTH_API.POST_LOGOUT,
    {
      refreshToken,
    },
    {
      skipAuth: true,
    },
  );
};
